export const officeListHeader = [
  { text: 'номер', value: 'supportNumber' },
  {
    text: 'Организация',
    align: 'left',
    sortable: false,
    value: 'organization.title',
  },
  {
    text: 'Название',
    align: 'left',
    sortable: false,
    value: 'title',
  },
  {
    text: 'Тип',
    align: 'left',
    sortable: false,
    value: 'type.title',
  },
  {
    text: 'Отрасль',
    align: 'left',
    sortable: false,
    value: 'industry.title',
  },
  {
    text: 'Код завода',
    align: 'left',
    sortable: false,
    value: 'externalCode',
  },
  {
    text: 'Статус',
    align: 'left',
    sortable: false,
    value: 'status',
  },
  {
    text: 'Адрес',
    align: 'left',
    sortable: false,
    value: 'address',
  },
  {
    text: 'Населенный пункт',
    align: 'left',
    sortable: false,
    value: 'city.title',
  },
  {
    text: 'Округ',
    align: 'left',
    sortable: false,
    value: 'province.title',
  },
  {
    text: 'Регион (Старый)',
    align: 'left',
    sortable: false,
    value: 'rawRegion',
  },
  {
    text: 'часовой пояс',
    align: 'left',
    sortable: false,
    value: 'location.timeZone.title',
  },
  { text: 'MeetPoint', value: 'root.meetPoint' },
  { text: 'Как добраться', value: 'transportation' },
  { text: 'isActive', value: 'isActive' },
  { text: 'Кол-во офферов', value: 'availableOffersNumber' },
  { text: 'Баланс', value: 'amount' },
  { text: 'юр. лицо', value: 'legalEntity.title' },
  { text: 'Контракт', value: 'contract.title' },
  { text: 'Новый объект', value: 'hasShiftStarterProviderLevel' },
  { text: 'Территория', value: 'territory.title' },
  { text: '', value: 'options' },
]
export const getOfficeListParamsFromFilter = (officeListFilterSet) => {
  const params = { }
  if (officeListFilterSet.searchQuery && officeListFilterSet.searchQuery.trim() !== '') {
    params.searchQuery = officeListFilterSet.searchQuery
  }
  if (officeListFilterSet.organization) {
    params['organization[id]'] = officeListFilterSet.organization
  }
  if (officeListFilterSet.status) {
    params['statusList[0]'] = officeListFilterSet.status
  }
  if (officeListFilterSet.type) {
    params['typeList[0][id]'] = officeListFilterSet.type
  }
  if (officeListFilterSet.region) {
    params['regionList[0][id]'] = officeListFilterSet.region
  }
  if (officeListFilterSet.city) {
    params['cityList[0][id]'] = officeListFilterSet.city
  }
  if (officeListFilterSet.shiftProviderLevel) {
    params.shiftProviderLevel = officeListFilterSet.shiftProviderLevel
  }

  return params
}

export const getActiveFilterNumber = (officeListFilterSet) => {
  const params = {
    ...officeListFilterSet,
  }

  for (const [key, value] of Object.entries(params)) {
    if (!(value || (!value && (value === '0' || value === 0)))) {
      delete params[key]
    }
  }

  return Object.keys(params).length
}

const OfficeListUtil = {
  officeListHeader,
  getActiveFilterNumber,
  getOfficeListParamsFromFilter
}

export default OfficeListUtil
